// extracted by mini-css-extract-plugin
module.exports = {"aceEditor":"styles_aceEditor__3OyNi"};